<div
  [ngClass]="{ 'default-card--with-custom-btn': withCustomButton() }"
  class="default-card {{ backgroundClass() }}"
  fxLayout="row"
  fxLayoutAlign="center center"
  matRipple
  [matRippleDisabled]="!icon()"
>
  @if (withCustomButton()) {
    <span class="default-card__custom-button">
      <ng-content select="[cardCustomButton]" />
    </span>
  } @else if (icon()) {
    <mat-icon class="default-card-icon">{{ icon() }}</mat-icon>
  }
  <span class="default-card-title">{{ title() }}</span>
</div>
